import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakPoints;

const Perks = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const Title = styled.h4`
  label: Title;

  color: var(--colors-silver);
  margin-bottom: 2.25rem;
  text-align: center;
`;

const Perk = styled.div`
  label: Perk;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2.25rem;
  color: var(--colors-white);

  @media (${widthSmall}) {
    max-width: 13.75rem;
  }

  @media (${widthMedium}) {
    max-width: 15.625rem;
    margin-bottom: 2rem;
  }
`;

const PerkIcon = styled.svg`
  label: PerkIcon;

  width: 2rem;
  display: block;
  flex: 0 0 auto;
  margin-bottom: 1rem;
  fill: ${({ color }) => `var(${color})`};

  @media (${widthSmall}) {
    width: 2.5rem;
  }
`;

const PerkDescription = styled.h4`
  label: PerkDescription;

  color: var(--colors-alabaster);
`;

const Styled = {
  Perks,
  Title,
  Perk,
  PerkIcon,
  PerkDescription,
};

export default Styled;
